module.exports = __webpack_public_path__ + "static/media/default-state.f0707281.svg";